import * as Tooltip from '@radix-ui/react-tooltip'

export function AppTooltipProvider({ children }) {
  return (
    <Tooltip.Provider delayDuration={180} skipDelayDuration={80}>
      {children}
    </Tooltip.Provider>
  )
}

export function AppTooltip({
  content,
  children,
  side = 'top',
  align = 'center',
  sideOffset = 8,
  contentClassName = '',
}) {
  if (!content) {
    return children
  }

  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          side={side}
          align={align}
          sideOffset={sideOffset}
          className={`z-[320] max-w-[260px] rounded-xl border border-outline-variant/25 bg-surface-container-lowest px-3.5 py-2.5 text-xs font-medium text-on-surface shadow-[0_10px_24px_rgba(15,23,42,0.2)] ${contentClassName}`}
        >
          {content}
          <Tooltip.Arrow className="fill-surface-container-lowest" />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  )
}

export function ChartTooltipSurface({ children, className = '' }) {
  return (
    <div
      className={`rounded border border-outline-variant/25 bg-surface-container-lowest px-3.5 py-2.5 shadow-[0_12px_28px_rgba(15,23,42,0.22)] backdrop-blur-sm transition-all duration-200 ease-out ${className}`}
    >
      {children}
    </div>
  )
}
